const userGridData = [
    {
        id: 1,
        name: 'Team Demo 1',
        designation: 'UI/UX Team',
        rule: 'Rule Demo 1',
        productivity: '75',
        email: 'david@skote.com'
    },
    {
        id: 2,
        image: require('@/assets/images/users/avatar-2.jpg'),
        name: 'Team Demo 2',
        designation: 'Frontend Team',
        rule: 'Rule Demo 2',
        productivity: '30',
        email: 'frank@skote.com'
    },
    {
        id: 3,
        image: require('@/assets/images/users/avatar-3.jpg'),
        name: 'Team Demo 3',
        designation: 'Backend Developer',
        rule: 'Rule Demo 3',
        productivity: '59',
        email: 'Rafael@skote.com'
    },
    {
        id: 4,
        name: 'Team Demo 4',
        designation: 'Full Stack Developer',
        rule: 'Rule Demo 4',
        productivity: '82',
        email: 'mark@skote.com'
    },
    {
        id: 5,
        image: require('@/assets/images/users/avatar-4.jpg'),
        name: 'Team Demo 5',
        designation: 'Frontend Developer',
        rule: 'Rule Demo 5',
        productivity: '90',
        email: 'minnie@skote.com'
    },
    {
        id: 6,
        image: require('@/assets/images/users/avatar-5.jpg'),
        name: 'Team Demo 6',
        designation: 'UI/UX Designer',
        rule: 'Rule Demo 6',
        productivity: '69',
        email: 'shirley@skote.com'
    },
    {
        id: 7,
        name: 'Team Demo 7',
        designation: 'Full Stack Developer',
        rule: 'Rule Demo 7',
        productivity: '45',
        email: 'john@skote.com'
    },
    {
        id: 8,
        image: require('@/assets/images/users/avatar-5.jpg'),
        name: 'Team Demo 8',
        designation: 'Full Stack Developer',
        rule: 'Rule Demo 8',
        productivity: '67',
        email: 'colin@skote.com'
    },
    {
        id: 9,
        name: 'Team Demo 1',
        designation: 'UI/UX Team',
        rule: 'Rule Demo 1',
        productivity: '75',
        email: 'david@skote.com'
    },
    {
        id: 10,
        image: require('@/assets/images/users/avatar-2.jpg'),
        name: 'Team Demo 2',
        designation: 'Frontend Team',
        rule: 'Rule Demo 2',
        productivity: '30',
        email: 'frank@skote.com'
    },
    {
        id: 11,
        image: require('@/assets/images/users/avatar-3.jpg'),
        name: 'Team Demo 3',
        designation: 'Backend Developer',
        rule: 'Rule Demo 3',
        productivity: '59',
        email: 'Rafael@skote.com'
    },
    {
        id: 12,
        name: 'Team Demo 4',
        designation: 'Full Stack Developer',
        rule: 'Rule Demo 4',
        productivity: '82',
        email: 'mark@skote.com'
    },
    {
        id: 13,
        image: require('@/assets/images/users/avatar-4.jpg'),
        name: 'Team Demo 5',
        designation: 'Frontend Developer',
        rule: 'Rule Demo 5',
        productivity: '90',
        email: 'minnie@skote.com'
    },
    {
        id: 14,
        image: require('@/assets/images/users/avatar-5.jpg'),
        name: 'Team Demo 6',
        designation: 'UI/UX Designer',
        rule: 'Rule Demo 6',
        productivity: '69',
        email: 'shirley@skote.com'
    },
    {
        id: 15,
        name: 'Team Demo 7',
        designation: 'Full Stack Developer',
        rule: 'Rule Demo 7',
        productivity: '45',
        email: 'john@skote.com'
    },
    {
        id: 16,
        image: require('@/assets/images/users/avatar-5.jpg'),
        name: 'Team Demo 8',
        designation: 'Full Stack Developer',
        rule: 'Rule Demo 8',
        productivity: '67',
        email: 'colin@skote.com'
    },
];

export { userGridData };